import SpecialityChip from './SpecialityChip'
export default SpecialityChip
